const EMAIL_ERROR_MSG = 'Please enter a valid email address.';
const USERNAME_ERROR_MSG = 'Please enter a valid username and password.';

export { EMAIL_ERROR_MSG, USERNAME_ERROR_MSG };
